module.exports = __webpack_public_path__ + "static/media/sucess.d6b8295d.png";